export default {
  v3OfficialTopUpCenterTitle: 'Centro di Ricarica Ufficiale',
  v3OfficialTopUpCenterKeyword: 'Centro di Ricarica Ufficiale',
  v3OfficialTopUpCenterDescription: 'Centro di Ricarica Ufficiale',
  v3SafeAndFast: 'Sicuro, Senza rischi e Accreditato Immediatamente',
  v3Shop: 'Centro Commerciale',
  v3ShoppingCart: 'Carrello Shopping',
  v3MembershipCenter: 'Centro Privilegi (Centro Membri Premium)',
  v3Login: 'Accesso',
  v3Account: 'Account',
  v3EnterAccountName: 'Inserisci Nome Account',
  v3Password: 'Password',
  v3EnterPassword: 'Inserisci Password',
  v3ForgotPassword: 'Password Dimenticata',
  v3EnterUID: 'Inserisci UID',
  v3OTP: 'OTP',
  v3EnterOTP: 'Inserisci OTP',
  v3SelectTopUpCharacter: 'Seleziona Personaggio Ricarica',
  v3SelectServer: 'Seleziona Server',
  v3Confirm: 'Conferma',
  v3CharacterNotFound:
    'Se non riesci a trovare il personaggio, prova prima ad accedere al personaggio nel gioco, poi accedi alla pagina di ricarica o contatta il servizio clienti.',
  v3Logout: 'Disconnetti',
  v3SwitchAccount: 'Cambia Account',
  v3MyCoupons: 'I Miei Buoni',
  v3BenefitsCenter: 'Centro Privilegi',
  v3TopUpBenefits: 'Benefici Ricarica',
  v3MoreSettings: 'Impostazioni Aggiuntive',
  v3RememberLoginStatus: 'Memorizza il mio stato d’accesso',
  v3OrderQuery: 'Controlla Ordini',
  v3ContactCustomerService: 'Servizio Clienti',
  v3LoginWithApp: 'Accedi tramite App',
  v3ChooseOtherLoginMethod: 'Seleziona un metodo d’accesso alternativo',
  v3ConnectingToGameApp: 'Collegamento all’app di gioco',
  v3EnsureGameInstalled:
    "Assicurati che il gioco sia installato su questo dispositivo. Se il gioco non risponde o l'accesso non riesce, aggiorna i giochi all'ultima versione dall'app store o passa a un altro browser.",
  v3OpenGame: 'Avvia Gioco',
  v3DownloadGame: 'Scarica Gioco',
  v3UpdateGameIfOpenFails:
    "Se il gioco non si avvia, aggiornalo all'ultima versione dall'App Store/Google Play.",
  v3ClickToDownloadLatestVersion:
    'In alternativa, puoi cliccare sul pulsante scarica il gioco per ottenere la versione più recente.',
  v3LoggingIntoOfficialTopUpCenter:
    "Stai effettuando l'accesso al [Centro di Ricarica Ufficiale]",
  v3CurrentAccount: 'Account attuale: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: 'Benvenuto al Centro di Ricarica Ufficiale',
  v3OfficialAuthorizedLogin:
    'Accesso ufficialmente autorizzato. Nessun rischio per la sicurezza.',
  v3TermsOfService: 'Termini di Servizio',
  v3PrivacyPolicy: 'Politica sulla Privacy',
  v3ThirdPartySocialAccountDescription:
    'Informazioni sugli Account di Social Media di Terze Parti',
  v3BindSocialAccountInGameFirst:
    "Per prima cosa, completa l'associazione del tuo account social media nel Centro Utenti del gioco, quindi accedi con l'account social media associato.",
  v3FirstTopUp15PercentOff:
    'Approfitta di uno SCONTO fino al 15% sulla tua prima ricarica',
  v3MoreTopUpRebates: 'Ulteriori sconti e ricompense di ricarica',
  v3LoginToViewOffers: 'Accedi per visualizzare gli sconti',
  v3TopUpEnvironmentChecking: "Verifica dell'environment di ricarica...",
  v3SafeToUse: 'Sicuro e protetto.',
  v3LimitedTimeBenefits: 'Offerta Esclusiva a Tempo Limitato',
  v3EventRules: 'Regole Evento',
  v3MoreEvents: 'Più Eventi',
  v3Claim: 'Rivendica',
  v3Completed: 'Completato',
  v3GoTo: 'Vai',
  v3ViewDetails: 'Visualizza Dettagli',
  v3RecommendedProducts: 'Oggetti Consigl.',
  v3SearchProductName: 'Cerca oggetto per nome',
  v3AllCategories: 'Tutte',
  v3PopularSort: 'Caldo',
  v3PriceAscending: 'Prezzo ↑',
  v3PriceDescending: 'Prezzo ↓',
  v3DiamondBonus10Percent: 'Diamante +10%',
  v3YuanbaoBonus10Percent: 'Lingotto +10%',
  v3ExtraBonus10Percent: 'Bonus: 10%',
  v3FirstTopUpDouble: '1ma Ricarica Raddoppiata',
  v3FirstExtraBonus: 'Bonus 1ma Volta',
  v3ProductDetails: 'Dettagli Prodotto',
  v3AddToCart: 'Aggiungi al Carrello',
  v3AddedToCart: 'Aggiunto al Carrello',
  v3BuyNow: 'Acquista Ora',
  v3NoItemsInCart: 'Ancora nessun oggetto nel tuo carrello',
  v3SelectedItemsN: 'Oggetti selezionati: (${n})',
  v3RemoveFromCart: 'Rimuovi dal carrello?',
  v3Yes: 'Sì',
  v3No: 'No',
  v3LimitOnePerPurchase:
    'È possibile acquistare solo uno di questi oggetti alla volta',
  v3ItemPrice: 'Prezzo Oggetto',
  v3Tax: 'Tassa',
  v3ExtraGift: 'Bonus',
  v3Total: 'Totale',
  v3ProceedToPayment: 'Paga',
  v3SelectCoupon: 'Seleziona Buono',
  v3UnavailableCoupons: 'Buoni Non Utilizzabili',
  v3OneCouponPerOrder: 'Un buono per ordine',
  v3DiscountCoupon: 'Buono Sconto',
  v3ThresholdCoupon: 'Detrazione Buono',
  v3MinSpendCoupon: 'Utilizzabile quando il prezzo totale supera xx USD',
  v3MaxDiscountCoupon: 'Sconto fino a xxxx USD',
  v3LimitedChannel: 'Limitato a canali specifici',
  v3AllChannels: 'Disponibile per tutti i canali',
  v3SpecificProducts: 'Solamente oggetti specifici',
  v3AllProducts: 'Per tutti gli oggetti',
  v3NotYetTimeToUse: 'Ancora non utilizzabile',
  v3Expired: 'Scaduto',
  v3Used: 'Usato',
  v3ValidityPeriod: 'Validità:',
  v3ConfirmUse: 'Conferma',
  v3ChangeProduct: 'Cambia Oggetto',
  v3ConfirmPaymentOrder: 'Conferma Ordine',
  v3StoredValueRole: 'Personaggio Ricarica',
  v3TotalNProducts: 'Oggetti totali: ${n}',
  v3SelectPaymentMethod: 'Seleziona Metodo di Pagamento',
  v3PayNow: 'Paga Ora',
  v3MorePaymentMethods: 'Più Metodi di Pagamento',
  v3NoAvailablePaymentMethodContactSupport:
    'Non trovi alcun metodo di pagamento disponibile? Contatta il Servizio Clienti.',
  v3AvailableCoupons: 'Buoni Utilizzabili',
  v3Extra10Percent: '0.1',
  v3LastSelection: 'Scelta Precedente',
  v3RecommendedUsage: 'Consigliato',
  v3PopularChoice: 'Scelta Popolare',
  v3PaymentSuccess: 'Pagamento Effettuato',
  v3PaymentFailure: 'Pagamento Non Riuscito',
  v3TopUpFailureMessage:
    "Spiacenti, la ricarica non è riuscita. Prova a inviare nuovamente l'ordine o contatta il servizio clienti.",
  v3Game: 'Gioco',
  v3UID: 'UID',
  v3OrderNumber: 'Ordine N.',
  v3ProductContent: 'Dettagli Oggetto',
  v3ViewProductDetails: 'Visualizza Dettagli Oggetto',
  v3PaymentMethod: 'Metodo di Pagamento',
  v3Complete: 'Completa',
  v3TopUpAgain: 'Ricarica di Nuovo',
  v3FriendlyReminderSaveOrderInfo:
    "Promemoria: Salva le informazioni del tuo ordine tramite screenshot per un'elaborazione più rapida.",
  v3RechargeAgain: 'Ricarica di Nuovo',
  v3TransactionInProgress: 'Elaborando transazione',
  v3CompletePaymentInChannel:
    'Per completare il pagamento, procedere al canale di pagamento.',
  v3RestAssuredFastDeliveryAfterPayment:
    "L'oggetto ti verrà spedito una volta ricevuto l'esito del pagamento.",
  v3SaveOrderInfoForProgress:
    "È possibile effettuare uno screenshot delle informazioni dell'ordine per monitorare l'avanzamento della transazione.",
  v3PaymentCompleted: 'Il pagamento è stato completato',
  v3AddToHomeScreen: 'Aggiungi alla schermata Home',
  v3AddShortcutForBonus:
    'Aggiungi una scorciatoia per ricevere ricompense aggiuntive',
  v3ShareSuccess: 'Condiviso',
  v3ShareFailure: 'Impossibile condividere',
  v3RewardClaimed: 'Ricompensa Rivendicata',
  v3RewardClaimFailed: 'Impossibile rivendicare la ricompensa',
  v3EventNotStarted: 'L’evento non è ancora iniziato',
  v3EventEnded: 'L’evento è terminato',
  v3ClickSelectCoupon: 'Clicca per selezionare il coupon',
  v3CouponsRecommendedUsed: 'Coupon consigliato utilizzato',
  v3CouponsSelected: 'Coupon selezionato',
  v3NoCouponsAvaliable: 'Nessun coupon disponibile',
  v3SupplementStatus: 'Stato',
  v3SupplementNormal: 'Normale',
  v3SupplementBanned: 'Bloccato',
  v3SupplementPendingPayment: 'In attesa di pagamento',
  v3SupplementSwitchCharacter: 'Cambia personaggio',
  v3SupplementAccountInfoInvalid: 'Informazioni account non valide',
  v3SupplementContactGSForTopUpLink: 'Contatta GS per il link di ricarica',
  v3SupplementTopUpCompleted: 'Ricarica completata:',
  v3SupplementTotalRefundOrders: 'Totale ordini di rimborso: {}',
  v3SupplementPendingSupplementAmount: 'Importo in attesa di pagamento:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Account/personaggio normale, nessun pagamento necessario',
  v3SupplementEnjoyYourGame: 'Buon divertimento con il gioco!!',
  v3SupplementOrderInformation: "Informazioni sull'ordine",
  v3SupplementPendingPaymentAmount: 'Importo in sospeso:',
  v3LookUpCouponRule: 'Controlla Regole Distribuzione Buono',
  v3SwitchOldVersion: 'Passa alla Vecchia Piattaforma di Pagamento',
  v3FirstTopUpGiveaway: 'Bonus 1ma Ricarica',
  v3SecureConnection: 'Stabilimento connessione sicura',
  v3RequestTimeOut: 'Caricamento non riuscito. Riprova più tardi.',
  v3ConfirmLeave: 'Uscire?',
  v3NoSubmitOrder:
    'Hai degli articoli nel carrello. Se esci ora, andranno persi.',
  v3ContinueSubmit: 'Continua',
  v3LeaveSubmit: 'Esci',
  v3RecentBug: 'Acquisti recenti',
  v3PwaTapShareOrMenuIcon: 'Tocca l\'icona Condividi o Menu nella barra degli strumenti del browser',
  v3PwaFindAndTapAddToHomeScreen: 'Trova e tocca "Aggiungi alla schermata Home" nelle opzioni',
  v3LaunchFromDesktopAndRewardToMailbox: 'Please launch from the desktop\nSelect a character and the reward will be sent to your mailbox',
  v3ClaimSuccessCheckMailbox: 'Riscattato con successo\nControlla la tua posta in gioco'
};
